/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Industry } from '@app/settings/industries/industries.model';
import { IndustriesFormComponent } from '@app/settings/industries/industries-form/industries-form.component';

@Injectable({
  providedIn: 'root',
})
export class IndustriesFormService {
  constructor(private modalService: NgbModal) {}

  /**
   * Open Industry form
   * @param industry Dialog data
   */
  public open(industry: null | Industry = null) {
    const modal = this.modalService.open(IndustriesFormComponent);
    modal.componentInstance.industry = industry;
    return modal.result;
  }
}
